import { render, staticRenderFns } from "./Swagger.vue?vue&type=template&id=16a81774&"
import script from "./Swagger.vue?vue&type=script&lang=js&"
export * from "./Swagger.vue?vue&type=script&lang=js&"
import style0 from "./Swagger.vue?vue&type=style&index=0&id=16a81774&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports